import React, { useMemo } from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import messages from 'containers/QuestionnairePage/messages';
import { SETTINGS_TOOLTIP_TYPES } from 'components/NodeHeaderSettings/constants';

import { isGroup } from 'utils/nodeTypes';
import {
  getRemoveOrRestoreTooltipMessage,
  withLogicDescriptionMessage,
  withLogicTitleMessage,
} from '../../utils';
import { getType } from '../utils';

function useModalLogicTitleAndDescription(valueType, nodeType, hasFeatures) {
  return useMemo(() => {
    const type = getType(valueType);
    const isNodeGroup = isGroup(nodeType);
    const tooltipTitle = withLogicTitleMessage(type);
    const { tooltipValues } = getRemoveOrRestoreTooltipMessage(
      SETTINGS_TOOLTIP_TYPES.DELETE,
      valueType,
      nodeType,
    );

    let tooltipDescription;
    const featuresDescription = messages.confirmModal.node.bodyAfter;
    if (isNodeGroup && hasFeatures) {
      tooltipDescription = messages.confirmModal.node.bodyGroupNodeWithFeatures;
    } else if (isNodeGroup && !hasFeatures) {
      tooltipDescription = messages.confirmModal.node.bodyGroupNode;
    } else {
      tooltipDescription = withLogicDescriptionMessage(type);
    }

    return {
      logicTitle: <FormattedMessage {...tooltipTitle} values={tooltipValues} />,
      logicDescription: (
        <FormattedHTMLMessage {...tooltipDescription} values={tooltipValues} />
      ),
      featuresDescription: (
        <FormattedHTMLMessage {...featuresDescription} values={tooltipValues} />
      ),
    };
  }, [valueType, nodeType, hasFeatures]);
}

export default useModalLogicTitleAndDescription;
